customElements.whenDefined('scroll-carousel').then(() => {

  /*
   * ============================================================
   * PRODUCT GALLERY - INFINITE SINGLE-SLIDE NAVIGATION
   * ============================================================
   *
   * The carousel displays 2 slides at a time, but:
   *
   * Next:
   *   1,2 -> 2,3 -> 3,4 -> 4,5 ...
   *
   * Previous:
   *   4,5 -> 3,4 -> 2,3 -> 1,2 ...
   *
   * At the boundaries it loops infinitely.
   *
   * ============================================================
   */


  /*
   * ------------------------------------------------------------
   * FIND CAROUSEL
   * ------------------------------------------------------------
   */

  const carousel = document.querySelector(
    'scroll-carousel[adaptive-height]'
  );

  if (!carousel) {
    console.warn('Product gallery carousel not found.');
    return;
  }


  /*
   * Make sure Shopify's ScrollCarousel class has been
   * initialized and provides the select() method.
   */

  if (typeof carousel.select !== 'function') {
    console.error(
      'ScrollCarousel is loaded, but select() is not available.'
    );
    return;
  }


  /*
   * ------------------------------------------------------------
   * FIND NAVIGATION BUTTONS
   * ------------------------------------------------------------
   */

  const nextButton = document.querySelector(
    'carousel-next-button button'
  );

  const prevButton = document.querySelector(
    'carousel-prev-button button'
  );

  if (!nextButton || !prevButton) {
    console.warn(
      'Product gallery navigation buttons were not found.'
    );
    return;
  }


  /*
   * ------------------------------------------------------------
   * GET ORIGINAL PRODUCT IMAGES
   * ------------------------------------------------------------
   *
   * Your HTML structure is:
   *
   * <scroll-carousel>
   *     <div class="product-gallery__media"></div>
   *     <div class="product-gallery__media"></div>
   *     <div class="product-gallery__media"></div>
   *     ...
   * </scroll-carousel>
   *
   * Only direct children are selected here.
   */

  const originalSlides = Array.from(
    carousel.querySelectorAll(
      ':scope > .product-gallery__media'
    )
  );


  /*
   * Nothing to do if there is only one image.
   */

  if (originalSlides.length <= 1) {
    return;
  }


  const totalSlides = originalSlides.length;


  /*
   * ------------------------------------------------------------
   * CREATE CLONES
   * ------------------------------------------------------------
   *
   * Original:
   *
   * 1  2  3  4 ... 15 16
   *
   * Becomes:
   *
   * CLONE16  1  2  3  4 ... 15 16  CLONE1
   *
   * Internal indexes:
   *
   * 0          = clone of 16
   * 1          = real 1
   * 2          = real 2
   * ...
   * 16         = real 16
   * 17         = clone of 1
   *
   */


  const firstClone = originalSlides[0].cloneNode(true);

  const lastClone =
    originalSlides[totalSlides - 1].cloneNode(true);


  /*
   * ------------------------------------------------------------
   * CLEAN CLONE IDS
   * ------------------------------------------------------------
   *
   * cloneNode(true) can duplicate IDs contained inside
   * the product media. Remove them so the DOM doesn't have
   * duplicate IDs.
   */

  function cleanClone(clone) {

    if (clone.id) {
      clone.removeAttribute('id');
    }

    clone.querySelectorAll('[id]').forEach(element => {
      element.removeAttribute('id');
    });

    clone.setAttribute(
      'data-infinite-carousel-clone',
      'true'
    );
  }


  cleanClone(firstClone);
  cleanClone(lastClone);


  /*
   * ------------------------------------------------------------
   * INSERT CLONES
   * ------------------------------------------------------------
   */

  carousel.insertBefore(
    lastClone,
    carousel.firstElementChild
  );

  carousel.appendChild(firstClone);


  /*
   * ------------------------------------------------------------
   * CURRENT SLIDE
   * ------------------------------------------------------------
   *
   * We start on the first REAL slide.
   *
   * 0 = clone last
   * 1 = real first
   * 2 = real second
   * ...
   */

  let currentIndex = 1;


  /*
   * Prevent multiple clicks while the smooth scroll is
   * taking place.
   */

  let isAnimating = false;


  /*
   * ------------------------------------------------------------
   * INITIAL POSITION
   * ------------------------------------------------------------
   */

  carousel.select(1, {
    instant: true
  });


  /*
   * ------------------------------------------------------------
   * TRANSITION DURATION
   * ------------------------------------------------------------
   *
   * Shopify's carousel normally uses a smooth scroll.
   * 350ms matches the timing used in your original script.
   */

  const transitionDuration = 350;


  /*
   * ------------------------------------------------------------
   * HELPER
   * ------------------------------------------------------------
   */

  function unlockCarousel() {

    setTimeout(() => {
      isAnimating = false;
    }, 50);

  }


  /*
   * ============================================================
   * NEXT BUTTON
   * ============================================================
   */

  nextButton.addEventListener(
    'click',
    function(event) {

      /*
       * Stop Shopify's default next() behavior.
       *
       * This is important because Shopify sees two visible
       * cells and may move by 2 cells.
       */
      event.preventDefault();
      event.stopImmediatePropagation();


      /*
       * Ignore clicks while animation is running.
       */
      if (isAnimating) {
        return;
      }


      isAnimating = true;


      /*
       * --------------------------------------------------------
       * NORMAL NEXT
       * --------------------------------------------------------
       *
       * 1 -> 2
       * 2 -> 3
       * 3 -> 4
       * ...
       */

      if (currentIndex < totalSlides) {

        currentIndex++;

        carousel.select(currentIndex);

        setTimeout(() => {
          isAnimating = false;
        }, transitionDuration);

        return;
      }


      /*
       * --------------------------------------------------------
       * INFINITE LOOP
       * --------------------------------------------------------
       *
       * We're currently at:
       *
       * [15][16]
       *
       * Move to:
       *
       * [16][CLONE1]
       *
       * Then instantly jump to:
       *
       * [1][2]
       */

      currentIndex = totalSlides + 1;

      carousel.select(currentIndex);


      setTimeout(() => {

        /*
         * Instant jump back to real first slide.
         */
        carousel.select(1, {
          instant: true
        });

        currentIndex = 1;

        unlockCarousel();

      }, transitionDuration);

    },
    true
  );


  /*
   * ============================================================
   * PREVIOUS BUTTON
   * ============================================================
   */

  prevButton.addEventListener(
    'click',
    function(event) {

      /*
       * Stop Shopify's default previous() behavior.
       */
      event.preventDefault();
      event.stopImmediatePropagation();


      /*
       * Ignore clicks while animation is running.
       */
      if (isAnimating) {
        return;
      }


      isAnimating = true;


      /*
       * --------------------------------------------------------
       * NORMAL PREVIOUS
       * --------------------------------------------------------
       *
       * 5 -> 4
       * 4 -> 3
       * 3 -> 2
       * 2 -> 1
       * ...
       */

      if (currentIndex > 1) {

        currentIndex--;

        carousel.select(currentIndex);

        setTimeout(() => {
          isAnimating = false;
        }, transitionDuration);

        return;
      }


      /*
       * --------------------------------------------------------
       * INFINITE LOOP
       * --------------------------------------------------------
       *
       * We're currently at:
       *
       * [1][2]
       *
       * Move backwards to:
       *
       * [CLONE16][1]
       *
       * Then instantly jump to:
       *
       * [15][16]
       */

      currentIndex = 0;

      carousel.select(0);


      setTimeout(() => {

        /*
         * Instant jump to real last slide.
         */
        carousel.select(totalSlides, {
          instant: true
        });

        currentIndex = totalSlides;

        unlockCarousel();

      }, transitionDuration);

    },
    true
  );


  /*
   * ============================================================
   * HANDLE MANUAL SWIPING / DRAGGING
   * ============================================================
   *
   * If the customer swipes the carousel manually, keep our
   * currentIndex synchronized with Shopify's carousel.
   *
   * This prevents the buttons from becoming out of sync.
   */

  carousel.addEventListener(
    'carousel:select',
    function(event) {

      /*
       * Don't interfere while our infinite-loop transition
       * is taking place.
       */
      if (isAnimating) {
        return;
      }


      const index = event.detail?.index;


      if (typeof index !== 'number') {
        return;
      }


      /*
       * Only track REAL slides.
       *
       * Clone indexes 0 and totalSlides + 1 are handled
       * by the infinite-loop code above.
       */

      if (
        index >= 1 &&
        index <= totalSlides
      ) {

        currentIndex = index;

      }

    }
  );


});